import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import API from "../../Network/API";

export default function TutorTransaction(){
       const { t } = useTranslation();
       const dispatch = useDispatch();
           const [data,setData]=useState()
      
            useEffect(() => {
                
                API.get(`/v1/oauth/teacher/transactions`)
                .then((response) => {
                    setData(response.data.data)
                }).catch((error) => {
                });
        
            }, []);

    return (
        <>
        <div className="dashboard-title">
                <h4>{t("tutorTransaction.transaction_history")}</h4>
            </div>
            <div className="row">
            <div className="col-12">
            <div className="table-responsive custom-table">
                                <table className="table table-nowrap mb-0">
                                    <thead>
                                        <tr className="fw-bold">
                                            <th>{t("tutorTransaction.date")}</th>
                                            <th>{t("tutorTransaction.type")}</th>
                                            <th>{t("tutorTransaction.note")}</th>
                                            <th>{t("tutorTransaction.amount")}</th>
                                            <th>{t("tutorTransaction.fee")}</th>
                                            <th>{t("tutorTransaction.total")}</th>
                                           
                                        </tr>
                                    </thead>
                                    <tbody>

                                    {!data?.loading && data?.courses?.length > 0 && data?.courses?.map((course, j) => (
                                        <tr>
                                            <td data-label={t("tutorTransaction.date")}>{course.date}</td>
                                            <td data-label={t("tutorTransaction.type")}>{course.type}</td>
                                            <td data-label={t("tutorTransaction.note")}>{course.note}</td>
                                            <td data-label={t("tutorTransaction.amount")}>{course.amount}</td>
                                            <td data-label={t("tutorTransaction.fee")}>{course.fee}</td>
                                            <td data-label={t("tutorTransaction.total")}>{course.total}</td>
                                            
                                        </tr>
                                     ))}

                                    </tbody>
                                    </table>
                                    </div>
                </div>
                </div>
        </>
    )
}